interface TypeListGameProvider {
  [x: string]: string;
}
export const listGameProvider: TypeListGameProvider = {
  LC: "Live Casino",
  SL: "Slot",
  SB: "Sport",
  FH: "Fishing",
  ES: "E-Sport",
  BG: "Board Game",
  LT: "Lottery",
  KN: "Keno",
  CF: "Cook Fighting",
  OT: "Others",
};

interface TypeListMyVip {
  level: string;
  key: number;
}

export const LIST_MY_VIP: TypeListMyVip[] = [
  {
    level: "Vip0",
    key: 0,
  },
  {
    level: "Vip1",
    key: 1,
  },
  {
    level: "Vip2",
    key: 2,
  },
  {
    level: "Vip3",
    key: 3,
  },
  {
    level: "Vip4",
    key: 4,
  },
  {
    level: "Vip5",
    key: 5,
  },
  {
    level: "Vip6",
    key: 6,
  },
  {
    level: "Vip7",
    key: 7,
  },
];
